var _style, _g, _path, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0rsl{fill:#588443;}\r\n\t.st1rsl{fill:#FAC8AA;}\r\n\t.st2rsl{fill:#F9C2A0;}\r\n\t.st3rsl{fill:#4E382A;}\r\n\t.st4rsl{fill:#825716;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_1_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0rsl",
    cx: 150,
    cy: 150.3,
    r: 150
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1rsl",
    d: "M154.5,272c-0.7,0.1-1.5,0.2-2.3,0.2c-0.7,0.1-1.5,0.1-2.2,0.1c-0.7-0.1-1.3-0.2-2-0.3 c-1.7-0.3-3.2-0.6-4.7-0.9c0-50,0-100,0-150.1h12.3C155.2,171.4,154.8,221.7,154.5,272z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1rsl",
    d: "M93.6,94.3c-10.1,22.6-20.2,45.3-30.3,67.9c-1.8,6.5-6.8,27,4.3,39.7c0.8,0.9,1.8,1.9,2.8,2.7 c2.5,0.7,5,1.3,7.5,2c6.6,12.1,13.2,21.4,18.2,27.8c11.8,15.1,22.5,28.5,40.7,34.9c5.4,1.9,10.1,2.7,13.1,3.1 c0-60.1,0-120.3,0-180.4C131.2,92.8,112.4,93.5,93.6,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2rsl",
    d: "M235.9,161.4c-11.7-23.8-23.3-47.6-35-71.4c-17,0.7-33.9,1.4-50.9,2v180.4c2.6-0.1,6.5-0.5,11-1.6 c18.5-4.8,29.8-18.3,41.4-32.5c5.6-6.9,12.9-17,19.8-30.2c3.5-0.5,6.1-1.8,7.9-3.1C239.9,198.1,242.1,180.7,235.9,161.4z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3rsl",
    d: "M222.3,198.1c-0.8-3.8-1.6-8.4-1.7-13.7c-0.2-6.7,0.5-12.4,1.4-16.9c3.2-5.6,9.5-18.7,8.6-36.1 c-0.6-11.7-4.2-20.7-6.9-26.1c-1-4.5-2.7-9.9-5.8-15.5c-10.1-18.2-27.7-25.4-34.1-27.6c1.4-12-3.4-23.5-12.7-29.7 c-8.9-6-18.5-4.9-21.1-4.5c-2.7-0.4-12.2-1.5-21.1,4.5c-9.3,6.2-14.1,17.8-12.7,29.7c-6.5,2.3-24,9.4-34.1,27.6 c-3.1,5.6-4.8,10.9-5.8,15.5c-2.7,5.3-6.3,14.4-6.9,26.1c-0.9,17.4,5.5,30.5,8.6,36.1c0.9,4.5,1.6,10.2,1.4,16.9 c-0.2,5.3-0.9,9.9-1.7,13.7c-1.4,1.6-4,5-4.6,9.9c-0.8,7.1,3.1,14.4,10,18.8c0.9,0.3,8.4,3,10.2,10c0.5,2,0.4,3.8,0.2,5.2 c-0.5,0.9-1.8,3.4-1,4.2c0.9,0.8,3.9-0.6,5.5-2.2c4.1-4,2.6-11.3,2.2-13.1c-11.1-7.5-16.5-17.2-14-23.5c0.5-1.3,1.6-2.9,4-4.5 c-3.6-8.1-10.1-25.5-7.5-47.5c1.6-13.5,6-24,9.5-30.8c2.8-1.9,7-4.2,12.5-5.6c10.8-2.8,20-0.2,23.9,1.2c3.1,1.7,7,3.6,11.8,5.1 c3.5,1.1,6.7,1.7,9.5,2.1c2.8-0.4,6-1,9.5-2.1c4.8-1.5,8.7-3.4,11.8-5.1c4-1.4,13.1-4,23.9-1.2c5.5,1.4,9.7,3.7,12.5,5.6 c3.5,6.8,7.9,17.3,9.5,30.8c2.6,22-3.9,39.4-7.5,47.5c2.4,1.6,3.5,3.2,4,4.5c2.5,6.3-2.9,16-14,23.5c-0.4,1.8-1.9,9.1,2.2,13.1 c1.7,1.7,4.7,3.1,5.5,2.2c0.8-0.8-0.5-3.3-1-4.2c-0.2-1.4-0.3-3.2,0.2-5.2c1.8-7,9.3-9.6,10.2-10c6.9-4.4,10.8-11.7,10-18.8 C226.4,203.1,223.8,199.7,222.3,198.1z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4rsl",
    d: "M67.7,184.8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReyLogo);
export default __webpack_public_path__ + "static/media/rey-logo.94dfe0bf.svg";
export { ForwardRef as ReactComponent };